import React, { useState } from 'react'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import SegmentedToggleButton from 'components/segmented-toggle-button/mui5'
import { segmentedToggleButtonGroupSx } from 'lib/segmented-button-styles'

const YesNoToggle = ({ index, register, graduatedStatus }) => {
  const [response, setResponse] = useState(graduatedStatus)

  const handleResponse = (event, newResponse) => {
    if (newResponse !== null) {
      setResponse(newResponse)
    }
  }

  return (
    <ToggleButtonGroup
      value={response}
      exclusive
      onChange={handleResponse}
      aria-label="response"
      sx={segmentedToggleButtonGroupSx}
    >
      <input
        type="hidden"
        value={response}
        name={`students.${index}.status`}
        ref={register()}
      />
      <SegmentedToggleButton
        value="PASSED"
        groupValue={response}
        aria-label="Yes"
      >
        Yes
      </SegmentedToggleButton>
      <SegmentedToggleButton
        value="FAILED"
        groupValue={response}
        aria-label="No"
      >
        No
      </SegmentedToggleButton>
    </ToggleButtonGroup>
  )
}

export default YesNoToggle
